<template>
  <li v-if="visible && message && menuMessage(message.message)" :class="{ 'self': message && message.self, 'other': message && !message.self}">
    <messageMenu ref="menuMessage" :message="message" ></messageMenu>
  </li>

  <li v-else-if="message && surveyMessage(message.message)" :class="{ 'self': message && message.self, 'other otherSurvey': message && !message.self}">
      <messageSurvey v-if="isFaces(message.message)" ref="surveyMessage" :message="message" ></messageSurvey>
      <messageSurveyYesNo v-else-if="isYesNo(message.message)" :message="message"></messageSurveyYesNo>
  </li>

  <li v-else-if="message && visible" :class="{ 'self': message && message.self, 'other': message && !message.self}">
    <div class="containerMessage">
      <div class="msg" :style="{ 'background-color': message && !message.self ? $store.state.campaign.color : '#e8e7e7'}">
        <p v-linkify v-for="(item, index) in getEnters(message.message)"
              :message="item"
              :key="index"
         :style="{'color': invertColor($store.state.campaign.color)}" :class="{'black-text':message && message.self}">{{item}}</p>
        <attachments :files="message.attachments"></attachments>
      </div>
      <p>{{$moment(message.date).format('HH:mm')}}</p>
    </div> 
  </li>

  <li v-else-if="visible" class="other">
    <div class="load-3 msg padding-typing" :style="{ 'background-color': $store.state.campaign.color}">
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
    </div>
  </li>

</template>

<script>
import { mapGetters } from "vuex";
import Attachments from "./attachments";
import { invertColor } from "@/assets/utils"; 
import MessageMenu from "./messageMenu";
import MessageSurvey from "./messageSurvey";
import MessageSurveyYesNo from "./messageSurveyYesNo";
import linkify from 'vue-linkify';

export default {
  props: { message: Object, visible: Boolean },
  components: { Attachments, MessageMenu, MessageSurvey, MessageSurveyYesNo }, 
  name: "message",
 
  data() {
    return {

    };
  },

  computed: mapGetters([]),
  directives: {
      linkify
  },
  created(){
    if(this.menuMessage(this.message.message)){
      this.$emit('menuMessage', this);
    }
    if(this.surveyMessage(this.message.message)){
      this.$emit('surveyMessage', this);
    }
  },
  methods: {
    disableMenuMessage(message){
      if(this.$refs.menuMessage){
        this.$refs.menuMessage.disableMenuMessage(message);
      }
    },
    invertColor,
    menuMessage(message){
      return message.split(`\n`).every(text=> text.match(/[0-9]+ *- *[^]*/imy) != null)
    },
    getEnters(message){
      let msgWithEnters = message.split(String.fromCharCode(10));
      return msgWithEnters;
    },
    surveyMessage(message){
      if(message){
        let m = message.split(`\n`);
        if(m[0]== "(faces)" || m[0]=="(yes/no)"){
          m.shift();
          return m.every(text=> text.match(/[0-9]+ *- *[^]*/imy) != null);
        }
        return false;
      }
    },
    isFaces(message){
      if(message){
        let m = message.split(`\n`);
        return m[0]== "(faces)";
      }
      return false;
    },
     isYesNo(message){
      if(message){
        let m = message.split(`\n`);
        return m[0]== "(yes/no)";
      }
      return false;
    }
  }
};
</script>

<style scoped>

li {
  padding: 10px 0.5rem 0 0.5rem;
  overflow: hidden;
  display: flex;
}

.self {
  justify-content: flex-end;
  align-items: flex-end;
}

.other {
  justify-content: flex-start;
  align-items: flex-start;
}

.otherSurvey {
  justify-content: center !important;
  /* align-items: flex-start; */
}

.self .msg {
  background-color: #f8f8f8;
}

.other .msg {
  background-color: chocolate;
}

/* .otherSurvey .msg {
  background-color: chocolate;
} */

.containerMessage {
  max-width: 80%;
}

.containerMessage > p {
  color: #777;
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 12px;
}

.self > .containerMessage > p {
  margin-right: 7px;
  margin-top: 4px;
  text-align: right !important;
}

.other > .containerMessage > p {
  margin-right: 7px;
  margin-top: 4px;
  text-align: left !important;
}

::marker{
  
}
/* .otherSurvey > .containerMessage > p {
  margin-right: 7px;
  margin-top: 4px;
  text-align: left !important;
} */

.self .avatar {
  order: 2;
}

.msg {
  background: white;
  min-width: 50px;
  padding: 8px 20px;
  font-family: "Lato";
  font-weight: 400;
  word-wrap: break-word;
  border-radius: 20px;
}

.msg p {
  font-size: 1rem;
  margin: 0 0 0.2rem 0;
  margin-bottom: 0px !important;
  color: #777;
}

.msg img {
  position: relative;
  display: block;
  width: 450px;
  border-radius: 6px;
  box-shadow: 0px 0px 3px #eee;
  transition: all 0.4s cubic-bezier(0.565, -0.26, 0.255, 1.41);
  cursor: default;
  -webkit-touch-callout: none;
  user-select: none;
}

.black-text {
  color: black !important;
}

@media screen and (max-width: 800px) {
  .msg img {
    width: 300px;
  }
}

@media screen and (max-width: 550px) {
  .msg img {
    width: 200px;
  }
}

.msg time {
  font-size: 0.7rem;
  color: #ccc;
  margin-top: 3px;
  float: right;
  cursor: default;
  user-select: none;
}

.line {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 6px;
  background-color: white;
  float: right;
  margin-right: 2px;
}

.padding-typing {
  padding: 14px 20px;
}

.load-3 .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}

.load-3 .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}

.load-3 .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}


@keyframes loadingC {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 7px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>



// WEBPACK FOOTER //
// message.vue?be09de28